import React, {Component} from 'react';
import './Course.css';
import EmbedFile from "./EmbedFile";
import TestSubmitResult from "./TestSubmitResult";
import Communicate from "../common/Communicate";
import {catchDefault, GET_PARAMETERS, jsonOrThrow, post} from "../common/Http";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import {Link} from "react-router-dom";

const MAX_POSTPONE_DAYS = 14;
const MILLISECONDS_IN_DAY = 86400000;

function padTwo(value) {
    return value < 10 ? '0' + value : '' + value;
}

function formatLocalDate(date) {
    return date.getFullYear() + '-' + padTwo(date.getMonth() + 1) + '-' + padTwo(date.getDate());
}

class Test extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postponeEnabled: 0,
            blocked: false,
            communicate: undefined,
            type: props.type,
            course: props.course,
            testId: props.match.params.id || props.testId,
            loading: true,
            submitLoading: false,
            questions: [],
            questionsConfig: [],
            answers: {},
            postpone: 0,
            postponeDate: null,
            result: undefined
        };
    }

    componentDidMount() {
        this.refreshTimer = setInterval(() => this.forceUpdate(), 60000);
        this.betaSettingsUpdate();
        fetch(`${process.env.REACT_APP_API_URL}/course/test?id=${this.state.course.idco}&testId=${this.state.testId}`, GET_PARAMETERS)
            .then(jsonOrThrow)
            .then(data => {
                let questionsConfigLocal = [];
                let answersLocal = {};
                data.forEach((question) => {
                    // questionsConfigLocal.push(shuffle([1, 2, 3, 4]));
                    questionsConfigLocal.push([1, 2, 3, 4]);
                    answersLocal[`q_${question.idtq}`] = 0;
                });
                this.setState({
                    loading: false,
                    // questions: shuffle(data),
                    questions: data,
                    answers: answersLocal,
                    questionsConfig: questionsConfigLocal
                });
            })
            .catch(status => {
                if (status === 402) {
                    this.setState({
                        blocked: true
                    });
                } else {
                    catchDefault(status, this.props.history)
                }
            });
    }

    betaSettingsUpdate() {
        fetch(`${process.env.REACT_APP_API_URL}/account/beta`, GET_PARAMETERS)
            .then(jsonOrThrow)
            .then(data => {
                this.setState({
                    postponeEnabled: data['beta_postpone'],
                });
            })
    }

    componentWillUnmount() {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
        }
    }

    setAnswer(e) {
        const {name, value} = e.target;
        this.setState(prevState => {
            let answers = Object.assign({}, prevState.answers);
            answers[name] = value;
            return {answers};
        });
    }

    startOfLocalDay(date) {
        const day = new Date(date);
        day.setHours(0, 0, 0, 0);
        return day;
    }

    addLocalDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return this.startOfLocalDay(result);
    }

    /**
     * Number of calendar days between two dates. The comparison is done on the calendar
     * day numbers, so it is not affected by the daylight saving time changes
     * (a day may be 23 or 25 hours long).
     */
    calendarDaysBetween(from, to) {
        const fromDay = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
        const toDay = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
        return Math.round((toDay - fromDay) / MILLISECONDS_IN_DAY);
    }

    minPostponeDate() {
        return this.addLocalDays(new Date(), 1);
    }

    maxPostponeDate() {
        return this.addLocalDays(new Date(), MAX_POSTPONE_DAYS);
    }

    certificateGenerationDate() {
        return this.state.postponeDate ? formatLocalDate(this.state.postponeDate) : null;
    }

    handleDateChange(date) {
        if (!date) {
            this.setState({postpone: 0, postponeDate: null});
            return;
        }
        const diffDays = this.calendarDaysBetween(this.startOfLocalDay(new Date()), date);
        if (diffDays < 1 || diffDays > MAX_POSTPONE_DAYS) {
            this.setState({postpone: 0, postponeDate: null});
            return;
        }
        this.setState({postpone: diffDays, postponeDate: this.startOfLocalDay(date)});
    }

    setTest(e) {
        e.preventDefault();
        this.setState({
            submitLoading: true
        }, () => {
            fetch(`${process.env.REACT_APP_API_URL}/course/${this.state.type}/submit?postpone=${encodeURIComponent(this.certificateGenerationDate() || '')}&id=${this.state.course.idco}&testId=${this.state.testId}`, post(this.state.answers))
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw Error
                    }
                })
                .then(data => this.setState({
                    submitLoading: false,
                    communicate: '',
                    result: data
                }))
                .catch(() => {
                    this.setState({
                        submitLoading: false,
                        communicate: 'Wystąpił błąd, wynik nie został zapisany prawidłowo'
                    });
                });
        })
    }

    render() {
        return (
            this.state.blocked ?
                <div className="communicate error">
                    Z przykrością informujemy, że przypisana Izba Aptekarska, nie posiada obecnie dostępu do wybranego
                    przez Państwa testu.<br/>
                    W razie dodatkowych pytań prosimy o kontakt z Izbą Aptekarską.
                </div> :
                <div className="test-form">
                    {this.state.communicate ?
                        <Communicate communicate={this.state.communicate} error={true}/> : ''}
                    <h2>{this.state.course.name}</h2>
                    {this.state.result ?
                        <TestSubmitResult
                            reload={this.state.type !== 'test'}
                            course={this.state.course}
                            result={this.state.result.result}
                            resultStored={this.state.result.resultStored}
                            certificatePostponed={this.state.result.certificatePostponed}
                            certificateDate={this.state.result.postponedTo}
                            certificateIssued={this.state.result.certificateIssued}/> :
                        <div>
                            {this.state.questions.map((question, index) =>
                                <div key={index} className="test-row">
                                    <h3>{question.question}</h3>
                                    {question.file ?
                                        <EmbedFile file={question.file} folder={this.state.course.folder}/> : ''}
                                    {this.state.questionsConfig[index].map((answerIndex, i) =>
                                        question[`answer_${answerIndex}`] && question[`answer_${answerIndex}`].trim().length > 0 ?
                                            <div className="form-row" key={i}>
                                                <input type="radio"
                                                       id={`q_${question.idtq}_${i}`}
                                                       name={`q_${question.idtq}`}
                                                       value={answerIndex}
                                                       disabled={this.state.submitLoading}
                                                       checked={answerIndex === parseInt(this.state.answers[`q_${question.idtq}`])}
                                                       onChange={e => this.setAnswer(e)}/>
                                                <label htmlFor={`q_${question.idtq}_${i}`}>
                                                    {question[`answer_${answerIndex}`]}
                                                </label>
                                            </div> : ''
                                    )}
                                </div>
                            )}
                            {this.state.postponeEnabled > 0 ?
                                <div className="form-row">
                                    <label htmlFor="postpone">Data generacji certyfikatu: </label>
                                    <DatePicker
                                        id="postpone"
                                        disabled={this.state.submitLoading}
                                        onChange={date => this.handleDateChange(date)}
                                        value={this.state.postponeDate}
                                        minDate={this.minPostponeDate()}
                                        maxDate={this.maxPostponeDate()}
                                        className={"postpone-calendar"}
                                        clearIcon={null}
                                        format="y-MM-dd"
                                    />
                                    {this.state.postpone > 0 ?
                                        <button
                                            type="button"
                                            className="primary small"
                                            style={{marginLeft: '10px'}}
                                            onClick={() => this.setState({postpone: 0, postponeDate: null})}>
                                            Anuluj wybór daty
                                        </button> : ''}
                                    {this.state.postpone > 0 ?
                                        <p>Wynik zostanie wyświetlony natychmiast, certyfikat zostanie wystawiony
                                            w dniu {this.certificateGenerationDate()}.</p> :
                                        <p>Opcjonalnie wybierz datę wystawienia certyfikatu (od jutra do {formatLocalDate(this.maxPostponeDate())}).</p>}
                                </div> : <p onClick={() => this.betaSettingsUpdate()}>
                                    Aby edytować datę generacji certyfikatu należy włączyć opcję odroczenia w
                                    zakładce <Link target="_blank" to={'/account'}>Moje konto</Link> w sekcji
                                    "Ustawienia konta"
                                </p>}
                            <div className="form-row">
                                <button disabled={this.state.submitLoading}
                                        className={this.state.postpone > 0 ? 'secondary small' : 'primary small'}
                                        onClick={e => this.setTest(e)}>
                                    Wyślij
                                    odpowiedzi {this.state.postpone > 0 ? ' z datą wystawienia certyfikatu: ' + this.certificateGenerationDate() : ''}
                                </button>
                            </div>
                        </div>}
                </div>
        )
    }
}

export default Test;